<template>
  <footer>
    <div class="lianxi-box">
      <img class="fot-logo" src="@/assets/image/logo-b.png" alt="水石评级">
      <div style="width: 50%; display: flex; justify-content: space-between; flex-wrap: no-wrap; position: relative;"> 
        <div v-if="about" class="title-b-ty" style="font-size: 38px; vertical-align: middle; position: absolute; left: -220px; top: -10px;">联系我们<span style="color: #DDB055;">•</span></div>
        <ul class="lianxi-list">
          <li class="lianxi-item">
            <div class="lianxi-item-1">电话</div>
            <div class="lianxi-item-2">0531-88188888</div>
          </li>
          <li class="lianxi-item">
            <div class="lianxi-item-1">地址</div>
            <div class="lianxi-item-2">山东省济南市市中区二环南路</br>凯瑞大厦918室水石评级</div>
          </li>
        </ul>
        <div class="lianxi-item-img">
          <img src="https://www.shuishipingji.com/wap_new/footer-qrcode.jpg" alt="">
          <div>微信公众号</div>
        </div>
        <div class="lianxi-item-img">
          <img src="https://www.shuishipingji.com/wap_new/footer-minicode.png" alt="">
          <div>官方抖音号</div>
        </div>
      </div>
      
    </div>
    <div class="fot-bottom">
      <div>版权所有：山东水石文物鉴定有限公司</div>
      <div style="padding-top: 8px;">鲁ICP备2024121548号‑1</div>
    </div>

  </footer>
</template>

<script>
export default {
  props: {
    about: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
    }
  },
  methods: {
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
  footer{
    background-color: #111111;
    color: #fff;
    padding-bottom: 20px;
    .lianxi-box{
      width: 1300px;
      margin: 0 auto; 
      padding: 50px 0 30px;
      display: flex;
      justify-content: space-between; 
    }
    .fot-logo{
      width: 200px;
      height: 70px;
    }
    .lianxi-list{
      width: 40%;
      //padding-left: 20px;
    }
    .lianxi-item{
      margin-bottom: 40px;
      .lianxi-item-1{
        font-size: 14px;
        letter-spacing: 1px;
        margin-bottom: 5px;
        color: #ccc;
      }
      .lianxi-item-2{
        font-size: 20px;
      }
    }
    .lianxi-item-img{
      padding-top: 20px;
      img{
        width: 120px;
      }
      div{
        font-size: 16px;
        text-align: center;
        margin-top: 5px;
      }
    }
    .fot-bottom{
      text-align: center;
      margin-top: 30px;
      font-size: 12px;
      letter-spacing: 1px;
    }
  }
    
  
</style>